import { createSlice } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { requestSectionSettings } from './api/requestSectionSettings'
import { updateSectionSettings } from './api/updateSectionSettings'
import { PARTNER360_SECTION_SETTINGS_NAMESPACE } from './constants'
import { initialState } from './initialState'

const sectionSettingsSlice = createSlice({
  name: PARTNER360_SECTION_SETTINGS_NAMESPACE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestSectionSettings.pending, (state) => {
        state.status = RequestStatus.PENDING
      })
      .addCase(requestSectionSettings.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(requestSectionSettings.fulfilled, (state, action) => {
        state.settings = action.payload
        state.status = RequestStatus.FULFILLED
        state.message = 'Section settings fetched successful'
      })

      .addCase(updateSectionSettings.pending, (state) => {
        state.status = RequestStatus.PENDING
      })
      .addCase(updateSectionSettings.rejected, (state, action) => {
        state.status = RequestStatus.REJECTED
        if (action.error.message) {
          state.message = action.error.message
        }
      })
      .addCase(updateSectionSettings.fulfilled, (state, action) => {
        state.status = RequestStatus.FULFILLED
        state.message = 'Section settings updated successful'
        state.settings = {
          ...state.settings,
          ...action.payload,
        }
      })
  },
})

export default sectionSettingsSlice.reducer
